import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Upload = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M20 12.75V18a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-5.25M12 4v11.25M12 4l4.5 4.5M12 4 7.5 8.5'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 3.25a.75.75 0 0 1 .53.22l4.5 4.5a.75.75 0 0 1-1.06 1.06l-3.22-3.22v9.44a.75.75 0 0 1-1.5 0V5.81L8.03 9.03a.75.75 0 0 1-1.06-1.06l4.5-4.5a.75.75 0 0 1 .53-.22M4 12a.75.75 0 0 1 .75.75V18c0 .69.56 1.25 1.25 1.25h12c.69 0 1.25-.56 1.25-1.25v-5.25a.75.75 0 0 1 1.5 0V18A2.75 2.75 0 0 1 18 20.75H6A2.75 2.75 0 0 1 3.25 18v-5.25A.75.75 0 0 1 4 12'
        fill='currentColor'
      />
    )}
  </IconBase>
);
